.icon {
    color: rgba(0, 0, 0, 0.6);
    cursor: default;
    position: relative;
    top: 3px;
    font-size: 1.4rem;
    padding-bottom: 2px;
}
